import {
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import {
  customComponentListener,
  onFormFieldChangeType,
  radioConfig,
  textInputConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ComponentUtilsService, TranslationService } from '@core/services';
import { CustomRadioComponent, radioOptionSelected } from '@shared/components';
import { CustomTextInputComponent } from '@shared/components/text-input/text-input.component';

@Component({
  templateUrl: 'void-claim-modal-content.component.html',
  styleUrls: ['void-claim-modal-content.component.scss'],
  imports: [TranslateModule, ReactiveFormsModule, CustomRadioComponent],
})
export class VoidClaimModalContentComponent {
  @Output() onVoidClaimReasonInputChange = new EventEmitter<{
    reason: string | undefined;
  }>();

  @Input({ required: false }) listeners!: customComponentListener[];

  private translate = inject(TranslationService);

  protected reasonInputControl = new FormControl();

  private readonly utils = inject(ComponentUtilsService);

  protected radiosConfig = computed(
    () =>
      [
        {
          id: 'app.pageId.void-claim.reasons.provider-request',
          color: 'secondary',
          label: {
            key: 'app.pageId.void-claim.reasons.provider-request',
          },
        },
        {
          id: 'app.pageId.void-claim.reasons.patient-request',
          color: 'secondary',
          label: {
            key: 'app.pageId.void-claim.reasons.patient-request',
          },
        },
        {
          id: 'app.pageId.void-claim.reasons.other',
          label: {
            key: 'app.pageId.void-claim.reasons.other',
          },
          color: 'secondary',
          childComponent: {
            content: CustomTextInputComponent,
            data: {
              config: {
                inputType: 'textarea',
                fieldName: 'otherVoidReason',
                placeholder: {
                  key: 'app.pageId.void-claim.placeholder',
                },
                required: true,
              } as textInputConfig,
              listeners: [
                {
                  event: 'onFormFieldChange',
                  action: this.onOtherOptionFormFieldChanged.bind(this),
                },
              ],
            },
          },
        },
      ] as radioConfig[]
  );

  ngOnInit(): void {
    this.utils.attachListeners(this, this.listeners);

    this.reasonInputControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe(this.setValue.bind(this));
  }

  setValue(value: string) {
    this.onVoidClaimReasonInputChange.emit({
      reason: value.length > 0 ? value : undefined,
    });
  }

  onRadioOptionSelected = (event: radioOptionSelected) => {
    this.onVoidClaimReasonInputChange.emit({
      reason:
        event.option.toString() == 'app.pageId.void-claim.reasons.other'
          ? undefined
          : this.translate.translate({
              keys: [event.option.toString()],
            }),
    });
  };

  onOtherOptionFormFieldChanged = (event: onFormFieldChangeType) => {
    this.onVoidClaimReasonInputChange.emit({
      reason: event.value == undefined ? undefined : event.value.toString(),
    });
  };
}
